import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const NotificationIcon: TIconType = (props?: IIconProps) => {
	return (
		props?.isUnreadNotificationsCount
			? <svg
				data-testid='notifications-icon'
				fill='none'
				height='32'
				viewBox='0 0 32 32'
				width='32'
				{...props?.innerSvgProps}
			>
				{props?.isActive
					? <>
						<path
							d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
							fill='#DBDBF0'
						/>
						<path
							d='M13 25H19'
							stroke='#2E2E6B'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
						<path
							d='M9.78275 11.1589C9.44222 11.9802 9.26754 12.8608 9.26879 13.75V14.5C9.26879 17.8562 8.56567 19.8062 7.94692 20.875C7.8812 20.9888 7.84655 21.1179 7.84644 21.2493C7.84632 21.3808 7.88074 21.5099 7.94626 21.6239C8.01177 21.7378 8.10607 21.8325 8.21972 21.8985C8.33337 21.9645 8.46237 21.9995 8.59379 22H23.4063C23.5377 21.9995 23.6667 21.9645 23.7804 21.8985C23.894 21.8325 23.9883 21.7378 24.0538 21.6239C24.1193 21.5099 24.1538 21.3808 24.1536 21.2493C24.1535 21.1179 24.1189 20.9888 24.0532 20.875C23.4344 19.8062 22.7313 17.3562 22.7313 14L20.6054 14.329C19.8742 14.4421 19.1288 14.4257 18.4033 14.2806L18.2013 14.2402C17.4105 14.0821 16.6652 13.7488 16.02 13.265C15.3493 12.7619 14.8048 12.1096 14.4299 11.3596L14.3767 11.2532C14.1269 10.7536 13.9492 10.2211 13.849 9.67153L13.4537 7.50317C13.4537 7.50317 11.883 8.33686 11.253 8.96427C10.623 9.59168 10.1233 10.3375 9.78275 11.1589Z'
							fill='#2E2E6B'
							stroke='#2E2E6B'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</>
					: <>
						<path
							d='M13 25H19'
							stroke='#2E2E6B'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
						<path
							d='M13.4537 7.50317C12.6309 7.84029 11.883 8.33686 11.253 8.96427C10.623 9.59168 10.1233 10.3375 9.78275 11.1589C9.44222 11.9802 9.26754 12.8608 9.26879 13.75V14.5C9.26879 17.8562 8.56567 19.8062 7.94692 20.875C7.8812 20.9888 7.84655 21.1179 7.84644 21.2493C7.84632 21.3808 7.88074 21.5099 7.94626 21.6239C8.01177 21.7378 8.10607 21.8325 8.21972 21.8985C8.33337 21.9645 8.46237 21.9995 8.59379 22H23.4063C23.5377 21.9995 23.6667 21.9645 23.7804 21.8985C23.894 21.8325 23.9883 21.7378 24.0538 21.6239C24.1193 21.5099 24.1538 21.3808 24.1536 21.2493C24.1535 21.1179 24.1189 20.9888 24.0532 20.875C23.4344 19.8062 22.7313 17.8562 22.7313 14.5'
							fill='none'
							stroke='#2E2E6B'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</>

				}
				<circle
					cx='19.5'
					cy='8.5'
					fill='#D92644'
					r='4.5'
				/>
			</svg>
			: <svg
				data-testid='notifications-icon'
				fill='none'
				height='32'
				viewBox='0 0 32 32'
				width='32'
				{...props?.innerSvgProps}
			>
				<path
					d='M13 25H19'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M9.26879 13.75C9.26754 12.8608 9.44222 11.9802 9.78275 11.1589C10.1233 10.3375 10.623 9.59168 11.253 8.96426C11.883 8.33685 12.6309 7.84028 13.4537 7.50317C14.2765 7.16605 15.1578 6.99503 16.0469 6.99998C19.7594 7.02811 22.7313 10.1125 22.7313 13.8344V14.5C22.7313 17.8562 23.4344 19.8062 24.0532 20.875C24.1189 20.9888 24.1535 21.1179 24.1536 21.2493C24.1538 21.3808 24.1193 21.5099 24.0538 21.6238C23.9883 21.7378 23.894 21.8325 23.7804 21.8985C23.6667 21.9645 23.5377 21.9995 23.4063 22H8.59379C8.46237 21.9995 8.33337 21.9645 8.21972 21.8985C8.10607 21.8325 8.01177 21.7378 7.94626 21.6238C7.88074 21.5099 7.84632 21.3808 7.84644 21.2493C7.84655 21.1179 7.8812 20.9888 7.94692 20.875C8.56567 19.8062 9.26879 17.8562 9.26879 14.5V13.75Z'
					fill={props?.isActive ? colors.indigo70 : 'none'}
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
	);
};

export default NotificationIcon;
